import { render, staticRenderFns } from "./EmailRegisterView.vue?vue&type=template&id=48b045cc&"
import script from "./EmailRegisterView.vue?vue&type=script&lang=js&"
export * from "./EmailRegisterView.vue?vue&type=script&lang=js&"
import style0 from "./EmailRegisterView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports